import React, { Component } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { SalesOrderDetail } from './SalesOrderDetail';
import { Conflicts } from './Conflicts';

export class SalesOrderItems extends Component {
    displayName = SalesOrderItems.name;

    render() {
        return (
            <React.Fragment>
                <Tabs className={this.props.orderSubmitted ? 'orderSubmittedTop' : ''} selectedIndex={this.props.tabIndex} onSelect={tabIndex => this.props.setTab(tabIndex)}>
                    <TabList>               
                        <Tab style={{ textAlign: 'center', minWidth: '80px' }} disabled={this.props.hasConflicts}>All</Tab>
                        <Tab style={{ textAlign: 'center', minWidth: '80px' }} disabled={this.props.hasConflicts}>Fruit</Tab>
                        <Tab style={{ textAlign: 'center', minWidth: '80px' }} disabled={this.props.hasConflicts}>Veg</Tab>
                        <Tab style={{ textAlign: 'center', minWidth: '80px' }} disabled={this.props.hasConflicts}>Mixes/Mushrooms</Tab>
                        <Tab style={{ textAlign: 'center', minWidth: '80px' }} disabled={this.props.hasConflicts}>Specialties</Tab>                   
                        {this.props.hasConflicts &&
                            <Tab style={{ textAlign: 'center', minWidth: '80px', border: '2px solid red', color: 'Red', borderRadius: '2px', fontWeight: 'bolder' }} disabled>Conflicts</Tab>
                        }
                    </TabList>
                    <div className={this.props.orderSubmitted ? 'orderSubmittedTop' : (this.props.currOrder ? 'scrollContainerSmall' : 'scrollContainer')}>
             
                            <React.Fragment>
                                <TabPanel>
                                    <SalesOrderDetail
                                        orderGuideGroup={this.props.orderGuideGroup}
                                        salesOrderItems={this.props.salesOrderItems}
                                        updateRowComment={this.props.updateRowComment}
                                        updateRowQuantity={this.props.updateRowQuantity}
                                        updateRowOnKeyDown={this.props.updateRowOnKeyDown}
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <SalesOrderDetail
                                        orderGuideGroup={this.props.orderGuideGroup}
                                        salesOrderItems={this.props.salesOrderItems.filter((n) => n.productClass === 'FR')}
                                        updateRowComment={this.props.updateRowComment}
                                        updateRowQuantity={this.props.updateRowQuantity}
                                        updateRowOnKeyDown={this.props.updateRowOnKeyDown}
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <SalesOrderDetail
                                        orderGuideGroup={this.props.orderGuideGroup}
                                        salesOrderItems={this.props.salesOrderItems.filter(function (n) { return n.productClass === 'VE' && ((n.ogcDescription.indexOf("Mushroom") > -1) ? false : true) && ((n.ogcDescription.indexOf("Mix") > -1) ? false : true); })}
                                        updateRowComment={this.props.updateRowComment}
                                        updateRowQuantity={this.props.updateRowQuantity}
                                        updateRowOnKeyDown={this.props.updateRowOnKeyDown}
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <SalesOrderDetail
                                        orderGuideGroup={this.props.orderGuideGroup}
                                        salesOrderItems={this.props.salesOrderItems.filter(function (n) { return n.ogcDescription.indexOf("Mix") > -1 || n.ogcDescription.indexOf("Mushroom") > -1; })}
                                        updateRowComment={this.props.updateRowComment}
                                        updateRowQuantity={this.props.updateRowQuantity}
                                        updateRowOnKeyDown={this.props.updateRowOnKeyDown}
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <SalesOrderDetail
                                        orderGuideGroup={this.props.orderGuideGroup}
                                        salesOrderItems={this.props.salesOrderItems.filter((n) => n.productClass !== 'VE' && n.productClass !== 'FR')}
                                        updateRowComment={this.props.updateRowComment}
                                        updateRowQuantity={this.props.updateRowQuantity}
                                        updateRowOnKeyDown={this.props.updateRowOnKeyDown}
                                    />
                                </TabPanel>
                            </React.Fragment>
                      
                        {this.props.hasConflicts &&
                            <TabPanel>
                                <Conflicts
                                    orderGuideGroup={this.props.orderGuideGroup}
                                    salesOrderItems={this.props.conflicts}
                                    updateRowComment={this.props.updateRowComment}
                                    updateConflictRowQuantity={this.props.updateConflictRowQuantity}
                                    updateConflictRowOnKeyDown={this.props.updateConflictRowOnKeyDown}
                                />
                            </TabPanel>
                        }
                    </div>
                </Tabs>
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/SalesOrder/SalesOrderItems.js